export default __webpack_public_path__ + "static/media/Einsame-Blumen.e575790e.mp3";